import React from 'react';
import _isEqual from 'lodash/isEqual';
import _pickBy from 'lodash/pickBy';
import makeStyles from '@material-ui/core/styles/makeStyles';

import Switch from '@material-ui/core/Switch';
import { Typography } from '@material-ui/core';

interface Props {
  value: {
    onApp: { enabled: boolean };
    onSiftWeb: { enabled: boolean };
  };
  onChange: (key: string, value: any) => void;
}

function GroupMessage({ value, onChange }: Props) {
  const classes = useStyles();
  const { onApp, onSiftWeb } = value;
  const enabledOnApp = onApp.enabled;
  const enabledOnSiftWeb = onSiftWeb.enabled;

  const handleToggleGroupMessagingOnMsTeamsApp = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange('client.settings.groupMessage.msTeams.onApp.enabled', e.target.checked);
  };

  const handleToggleGroupMessagingOnSiftWeb = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange('client.settings.groupMessage.msTeams.onSiftWeb.enabled', e.target.checked);
  };

  return (
    <>
      <Typography variant="h6">Microsoft Teams Messaging (within app)</Typography>
      <div className={classes.content}>
        <Typography variant="subtitle2">
          Allow users to send a group Teams message while within Sift's Teams application. Messaging
          will use the person's email address.
        </Typography>
        <div>
          <Switch
            onChange={handleToggleGroupMessagingOnMsTeamsApp}
            checked={enabledOnApp}
            inputProps={{ 'aria-label': 'group message MS switch' }}
          />
        </div>
      </div>
      <Typography variant="h6">Microsoft Teams Messaging (on web)</Typography>
      <div className={classes.content}>
        <Typography variant="subtitle2">
          Allow users to send a group Teams message while within Sift's web application. Messaging
          will use the person's email address.
        </Typography>
        <div>
          <Switch
            onChange={handleToggleGroupMessagingOnSiftWeb}
            checked={enabledOnSiftWeb}
            inputProps={{ 'aria-label': 'group message web switch' }}
          />
        </div>
      </div>
    </>
  );
}

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

export default GroupMessage;
